// extracted by mini-css-extract-plugin
export var overlay = "panel-module--overlay--2IzX1";
export var panel = "panel-module--panel--2GcjR";